import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-video-quality-indicator',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './video-quality-indicator.component.html',
  styleUrls: ['./video-quality-indicator.component.scss']
})
export class VideoQualityIndicatorComponent implements OnChanges {

  @Input() qualityColor: 'ROJO' | 'NARANJA' | 'VERDE' | null = null;
  @Input() azimutalEnabled: -1 | 0 | 1 = -1;

  public qualityLabel: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['qualityColor']) {
      this.updateLabel();
    }
  }

  private updateLabel(): void {
    switch (this.qualityColor) {
      case 'VERDE':
        this.qualityLabel = 'BUENA';
        break;
      case 'NARANJA':
        this.qualityLabel = 'DEFICIENTE';
        break;
      case 'ROJO':
        this.qualityLabel = 'MALA';
        break;
      default:
        this.qualityLabel = '';
    }
  }

  get tooltipMessage(): string {
    // Mantenemos el tooltip detallado para información extra
    switch (this.qualityColor) {
      case 'VERDE': return 'Calidad de Video: Buena.';
      case 'NARANJA': return 'Calidad de Video: Deficiente. Afecta al análisis de la IA.';
      case 'ROJO': return 'Calidad de Video: Mala. Afecta al análisis de la IA.';
      default: return '';
    }
  }
}
